import './navigation';
import './customer-gallery.js';
import './products-filters.js';
import './testimonials.js';
import './product-gallery.js';
import './single-product.js';

import GLightbox from 'glightbox';

GLightbox({
    selector: ".glightbox3"
});
